import React, { useEffect, useState } from 'react';
import { css } from 'emotion';

// Components
import { Input as HangarInput } from '@maxmilhas/hangar-components-atomic/public';

export const Input = ({ value, icon, mask, onChange, ...rest }) => {
  const [inputValue, setInputValue] = useState('');
  const [inputMask, setInputMask] = useState(null);

  useEffect(() => {
    if (value) {
      setInputValue(`${value}`);
    }

    if (mask && typeof mask === 'string') {
      const _mask = new Function(`return ${mask}`)();
      setInputMask(_mask);
    } else if (typeof mask === 'function') {
      setInputMask(() => mask);
    } else if (mask) {
      setInputMask(mask);
    }
  }, []);

  const handleChange = event => {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    setInputValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <div className={css`${inputWrapper(icon)}`}>
      <HangarInput
        value={inputValue}
        mask={inputMask}
        onChange={handleChange}
        {...rest}
      />
    </div>
  );
};

const inputWrapper = hasIcon => `
  position: relative;

  > div {
    min-height: auto;

    > div {
      min-width: 1px;
      height: 24px;
    }

    input {
      padding-right: ${hasIcon ? 70 : 16}px;
    }

    hr {
      top: 36px;
    }

    i {
      top: 24px;
    }

    span[id*='input-error'] {
      display: none;
    }
  }
`;

export default Input;
